<template>
	<div class="errors-container" :class="classList">
		<ul>
			<li v-for="(error, index) in errors" :key="index" v-html="error"></li>
		</ul>
	</div>
</template>
<script>
	export default {
		name: "ErrorList",
		props: {
			errors: {
				required: false,
				type: Array
			},
			classList: {
				required: false,
				type: [String, Boolean]
			}
		}
	}
</script>